export default __webpack_public_path__ + "static/media/dribble.8284344c.svg";